import { useEffect } from "react";
import copilotDrawerStore from "Stores/copilotDrawerStore";
import { sortFindings } from "./findingsUtils";

// Publish a page's findings for as long as the page is on screen.
const usePageFindings = (list, key = "page") => {
  useEffect(() => {
    copilotDrawerStore.setPageFindings(sortFindings(list), key);
    return () => copilotDrawerStore.clearPageFindings(key);
  }, [list, key]);
};

export default usePageFindings;
